



























































import Vue from 'vue';
// import { mapState } from 'vuex';
import { BotData, Conversation, RequestFromUser } from '../store-types';
import { mdiVoice } from '@mdi/js';

interface ConvListBotInfo {
  id: string;
  name: string;
  status: 'waiting' | null;
  messageCount: number;
  // conversations: Conversation[];
}

interface ConversationListData {
  messageCount: number;
  conversationsByBot: {[botId: string]: Conversation[]};
}

interface ConversationListMethods {
  addConversation(botId: string, convId: string): void;
  addMessage(request: RequestFromUser): void;
  countBotMessages(bot: ConvListBotInfo): number;
  unsubscribe(): void;
}

interface ConversationListComputed {
  bots: ConvListBotInfo[];
}

export default Vue.extend({ // <ConversationListData, ConversationListMethods, ConversationListComputed, {}>({
    // name: "ConversationList.vue"
  data() {
    return {
      messageCount: 0,
      conversationsByBot: {} as {[botId: string]: Conversation[]},
      icons: {
          conversation: mdiVoice
      }
      // botMessageCounts: {}
    };
  },
  created() {
    (this as any).unsubscribe = this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case 'conversation_added':
          this.addConversation(mutation.payload);
          break;
        case 'message_added':
          this.addMessage(mutation.payload);
          break;
      }
    });
  },
  beforeDestroy() {
      (this as any).unsubscribe();
  },
  methods: {
    addConversation(payload: {botId: string, id: string}) {
      let convList: Conversation[] = this.conversationsByBot[payload.botId];
      if (!convList) {
        convList = [];
        Vue.set(this.conversationsByBot, payload.botId, convList);
      }

      const conv = this.$store.state.conversations[payload.id];
      if (conv) {
          Vue.set(conv, 'messageCount', 0);
          convList.push(conv);
      }
      return convList;
    },

    addMessage(request: RequestFromUser) {
      let convList = this.conversationsByBot[request.botId];
      if (!convList) {
          convList = this.addConversation({botId: request.botId, id: request.conversationId});
      }
      for (const conv of convList) {
        if (conv.id === request.conversationId) {
          Vue.set(conv, 'messageCount', conv.messageCount! + 1);
          const bot = this.bots.find(b => b.id === conv.botId);
          Vue.set(bot!, 'messageCount', bot!.messageCount + 1);
          break;
        }
      }

      convList.sort(compareConversations);
      this.bots.sort(compareBots);
    },

    countBotMessages(bot: ConvListBotInfo) {
      let messageCount = 0;
      const convList = this.conversationsByBot[bot.id];
      if (convList) {
        for (const conv of convList) {
          messageCount += conv.messageCount!;
        }
      }
      return bot.messageCount = messageCount;
    }
  },
  computed: {
    bots(): ConvListBotInfo[] {
      // console.info('get bots from store:', this.$store.state);
      this.messageCount = 0;
      const bots: ConvListBotInfo[] = [];
      for (const botId in this.$store.state.bots) {
        if (this.$store.state.bots.hasOwnProperty(botId)) {
          const bot: ConvListBotInfo = this.$store.state.bots[botId];

          // TODO: remove ------------
          /*bot.conversations = [];
          for (let i = 0; i < Math.floor(Math.random() * 10); i++) {
            const status = ['waiting', null][Math.floor(Math.random() * 2)];
            bot.conversations.push({
              id: 'conv-' + i,
              name: 'User ' + i,
              status,
              messageCount: Math.max(0, Math.floor((Math.random() * 2) - .5)) + (status === 'waiting' ? 1 : 0)
            });
          }*/
          // -------------------------

          // calculate the bot message Count
          this.messageCount += this.countBotMessages(bot);
          bots.push(bot);
        }
      }

      return bots.sort(compareBots);
    }
    /*conversationsByBot(): {[botId: string]: Conversation[]} {
      const conversationsByBot: {[botId: string]: Conversation[]} = {};

      for (const convId in this.$store.state.conversations) {
        if (this.$store.state.conversations.hasOwnProperty(convId)) {
          const conv: Conversation = this.$store.state.conversations[convId];
          let convList = conversationsByBot[conv.botId];
          if (!convList) {
            convList = conversationsByBot[conv.botId] = [];
          }
          convList.push(conv);
        }
      }

      console.info('conversationsByBot iterating through this.bots computed property...');
      for (const bot of this.bots) {
        const convList = conversationsByBot[bot.id];
        if (convList) {
          convList.sort(compareConversations);
        }
      }

      return conversationsByBot;
    }*/
  }
  /*, watch: {
    bots(bots) {
      // let messageCount = 0;
      // // const messageCounts = {};
      // for (const bot of bots) {
      //   console.info('bot conversations: ', bot.conversations);
      //   messageCount +=
      //     // messageCounts[bot.id] =
      //     bot.messageCount;
      // }
      // this.messageCount = messageCount;
      // this.botMessageCounts = messageCounts;
    }
  }*/
});


function compareBots(a: ConvListBotInfo, b: ConvListBotInfo) {
  let diff = b.messageCount - a.messageCount;

  if (diff === 0) {
    diff = a.name.localeCompare(b.name);
  }
  return diff;
}

function compareConversations(a: Conversation, b: Conversation) {
  // Waiting conversations 1st
  if (a.status === 'waiting') {
    if (b.status !== 'waiting') {
      return -1;
    }
  } else if (b.status === 'waiting') {
    return 1;
  }

  // then by message count
  let diff = b.messageCount! - a.messageCount!;

  if (diff === 0) {
    // then sort by name
    diff = (a.name || a.id).localeCompare(b.name || b.id);
  }

  return diff;
}
